<app-ion-common-header
  [id]="headerId"
  (backHeader)="backPage()"
  (focusHeader)="shownContent()"
  [title]="titlePage"
  start="{{ startStage }}"
  end="{{ endStage }}"
></app-ion-common-header>

<ion-content
  [attr.aria-hidden]="ariaHidden"
  [style.visibility]="ariaHidden ? 'hidden' : 'visible'"
>
  <app-ion-common-label
    [id]="idLabelDateTaxResidency"
    class="document-type-label1"
    labelStyle="display-rg"
    labelDescription="Qual a data de início da residência fiscal?"
  >
  </app-ion-common-label>

  <div class="conent-center conent-center--mrt-lg">
    <form [formGroup]="dateTaxResForm" (ngSubmit)="submitForm($event)">
      <app-ion-common-input
        [placeholder]="placeholder"
        [error]="error"
        [id]="idComponentName"
        [textError]="textError"
        minLength="10"
        maxLength="10"
        (textChange)="dataTaxRes = $event; errorMsg()"
        type="tel"
        [fieldValue]="dataTaxRes"
        [idLabel]="idLabel"
        [replaceStrTo]="'date'"
        [label]="label"
        [disabled]="!this.edit"
        name="docDateTaxRes"
        formControlName="docDateTaxRes"
        ngDefaultControl
      >
      </app-ion-common-input>
    </form>
  </div>
  <app-ion-common-button
    [id]="idButtonDateTaxResidency"
    class="hidden"
    [ngClass]="{ hidden: !buttonEnable || dataTaxRes?.length === 0 }"
    [attr.aria-hidden]="!buttonEnable"
    (clickButton)="clickNext()"
    label="Continuar"
  ></app-ion-common-button>
</ion-content>
